import arrayFilter from './_arrayFilter';
import baseXor from './_baseXor';
import isArrayLikeObject from './isArrayLikeObject';
import rest from './rest';

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [4, 2]);
 * // => [1, 4]
 */
var xor = rest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

export default xor;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/xor.js
// module id = 245
// module chunks = 0